import { useMemo } from 'react';
import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import { useMsalAuth } from './useMsalAuth';
import { createTmdsClient } from '../services/tmds';
import { parseItems, type AccessItem } from '../utils/parseItems';

export type { AccessItem };

const DEFAULT_QUERY_KEY = ['myaccess'] as const;

type MyAccessQueryOptions = Omit<UseQueryOptions<unknown, Error>, 'queryKey' | 'queryFn'>;

export type UseMyAccessDataResult = UseQueryResult<unknown, Error> & {
  items: AccessItem[] | null;
};

export function useMyAccessData(options?: MyAccessQueryOptions): UseMyAccessDataResult {
  const { getToken } = useMsalAuth();
  const client = useMemo(() => createTmdsClient(getToken), [getToken]);

  const query = useQuery({
    queryKey: DEFAULT_QUERY_KEY,
    queryFn: () => client.getMyAccess<unknown>(),
    ...options,
  });

  const items = parseItems(query.data);

  return {
    ...query,
    items,
  };
}
